import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import IconCheck from "@mui/icons-material/Check";
import IconDownload from "@mui/icons-material/CloudDownload";
import IconMenu from "@mui/icons-material/MoreVert";
import IconPrint from "@mui/icons-material/Print";
import IconColumns from "@mui/icons-material/ViewColumn";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showSnackbar } from "../../app/slices/commonSlice";
import "./appDataTable.css";
// import DownloadExcelDataTable from "./downloadExcel";
import DownloadPDFDataTable from "./downloadPDF";

const AppDataTable = ({
  data = [],
  columns = [],
  searchPlaceholder = "Search",
  actions = null,
  action = null,
  rowsPerPageOptions = [25, 100, 250],
  emptyMessage = "Nothing found!",
  id,
  downloadFileName = "List",
  hasBackground = true,
  dateFrom = null,
  dateTo = null,
  actionIcon = null,
  ...attrs
}) => {
  /* states */

  const [filteredData, setFilteredData] = useState(data);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [isOpenActions, setIsOpenActions] = useState(() => {
    let _initState = [];
    data.forEach((item) => {
      _initState.push(false);
    });

    return _initState;
  });

  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isShowingDownloadPopper, setIsShowingDownloadPopper] = useState(false);

  const [selectedSearchColumn, setSelectedSearchColumn] = useState("ALL");
  const [searchColumnOptions, setSearchColumnOptions] = useState([]);

  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const [columnsVisibility, setColumnsVisibility] = useState(() => {
    let _temp = [];
    columns.forEach((c) => {
      if ((c.options ?? {}).visible ?? true) {
        _temp.push(true);
      } else {
        _temp.push(false);
      }
    });
    return _temp;
  });

  const [isShowingVisibleColumnsPopper, setIsShowingVisibleColumnsPopper] =
    useState(false);

  const [visibleColumns, setVisibleColumns] = useState(() => {
    let _visibleColumns = [];

    columns.forEach((c) => {
      if ((c.options ?? {}).visible ?? true) {
        _visibleColumns.push(c);
      }
    });
    return _visibleColumns;
  });

  const [isOpenPDFViewer, setIsOpenPDFViewer] = useState(false);

  /* states */

  const navigate = useNavigate();
  const dispatch = useDispatch();

  /* useEffects */

  //searching
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(data);
    } else {
      let _list = [];
      data.forEach((item, index) => {
        let _matchFound = false;
        if (selectedSearchColumn === "ALL") {
          columns.forEach((col, _index) => {
            if (
              (item[col.name] ?? "")
                .toString()
                .toLowerCase()
                .replaceAll(",", "")
                .includes(searchQuery.toLowerCase().replaceAll(",", "")) &&
              !_matchFound
            ) {
              _list.push(item);
              _matchFound = true;
            }
          });
        } else {
          if (
            (item[selectedSearchColumn] ?? "")
              .toString()
              .toLowerCase()
              .replaceAll(",", "")
              .includes(searchQuery.toLowerCase().replaceAll(",", "")) &&
            !_matchFound
          ) {
            _list.push(item);
            _matchFound = true;
          }
        }
      });
      setFilteredData(_list);
      setCurrentPageNo(1);
    }
  }, [searchQuery, data, columns, selectedSearchColumn]);

  useEffect(() => {
    let _options = [
      {
        display: "All Columns",
        value: "ALL",
      },
    ];

    visibleColumns.forEach((c, i) => {
      _options.push({
        display: c.label,
        value: c.name,
      });
    });

    setSearchColumnOptions(_options);
    setSelectedSearchColumn("ALL");
  }, [visibleColumns]);

  useEffect(() => {
    if (sortColumn != null) {
      sortData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortColumn, sortOrder]);

  /* useEffects */

  /* helper methods */
  const doPrint = () => {
    navigate("/print", {
      state: {
        data: filteredData,
        columns: visibleColumns,
        title: downloadFileName,
        dateFrom: dateFrom,
        dateTo: dateTo,
      },
    });
  };

  const compare = (a, b) => {
    if (
      a[`${visibleColumns[sortColumn].name}`] <
      b[`${visibleColumns[sortColumn].name}`]
    ) {
      return -1;
    }
    if (
      a[`${visibleColumns[sortColumn].name}`] >
      b[`${visibleColumns[sortColumn].name}`]
    ) {
      return 1;
    }
    return 0;
  };

  const getColumnSortMarkerVisibility = (column) => {
    if (sortColumn !== null) {
      if (visibleColumns[sortColumn].name === column.name) {
        return "sort-marker-visible";
      } else {
        return "";
      }
    } else return "";
  };

  const handleColumnSort = (index) => {
    if (sortColumn === index) {
      reverseSortOrder();
    } else {
      // reverseSortOrder();
      setSortColumn(index);
    }
  };

  const reverseSortOrder = () => {
    if (sortOrder === "asc") {
      setSortOrder("desc");
    } else {
      setSortOrder("asc");
    }
  };

  const sortData = () => {
    let _sortedData = [...filteredData];
    _sortedData.sort(compare);
    if (sortOrder === "desc") {
      _sortedData = _sortedData.reverse();
    }
    setFilteredData(_sortedData);
  };

  const handleClickVisibleColumnItem = (index) => {
    let _columnsVisibility = [...columnsVisibility];

    //count visible columns
    let _countChecked = 0;
    columnsVisibility.forEach((i) => {
      if (i === true) {
        _countChecked++;
      }
    });

    //remove check only of it is not the last one, add check regardless
    if (
      _columnsVisibility[index] === false ||
      (_countChecked > 1 && _columnsVisibility[index] === true)
    ) {
      _columnsVisibility[index] = !_columnsVisibility[index];

      //reset visible columns
      let _visibleColumns = [];
      columns.forEach((col, _index) => {
        if (_columnsVisibility[_index] === true) {
          _visibleColumns.push(col);
        }
      });

      setSortColumn(null);
      setVisibleColumns(_visibleColumns);
      setColumnsVisibility(_columnsVisibility);
    }
  };

  /* helper methods */

  /* component builders */

  const BuildTableTopBar = () => {
    return (
      <div className="table-top-bar">
        {/* LEft Half */}
        <div className="left">
          <TextField
            id={`search-input-${id}`}
            variant="outlined"
            fullWidth
            margin="dense"
            value={searchQuery}
            placeholder={searchPlaceholder}
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
          />

          <TextField
            id={`search-column-select-${id}`}
            className="ml-5 w-180"
            variant="outlined"
            fullWidth
            select
            margin="dense"
            value={selectedSearchColumn}
            onChange={(e) => {
              setSelectedSearchColumn(e.target.value);
            }}
          >
            {searchColumnOptions.map((option) => {
              return (
                <MenuItem
                  id={`search-column-menu-item-${option.value}`}
                  key={option.value}
                  value={option.value}
                >
                  {option.display}
                </MenuItem>
              );
            })}
          </TextField>
        </div>

        {/* Right Half */}
        <div className="right">
          {/* Visible columns */}
          <Tooltip title="Visible Columns" placement="top">
            <IconButton
              className="action-button"
              id={`action-btn-visible-columns-${id}`}
              onClick={() => {
                setIsShowingVisibleColumnsPopper(true);
              }}
            >
              <IconColumns color="secondary" />
            </IconButton>
          </Tooltip>
          {isShowingVisibleColumnsPopper && (
            <div className="visible-columns-popper">
              <ClickAwayListener
                onClickAway={(e) => {
                  setIsShowingVisibleColumnsPopper(false);
                }}
              >
                <div>
                  <div className="popper-heading">Visible Columns</div>
                  <MenuList className="visible-columns-menu-list">
                    {columns.map((column, index) => (
                      <MenuItem
                        role="appbar-menu_item reduced-padding"
                        onClick={() => {
                          handleClickVisibleColumnItem(index);
                        }}
                      >
                        <div className="visible-columns-menu-item">
                          {/* <Checkbox
                            className="visible-columns-checkbox"
                            checked={columnsVisibility[index]}
                            key={`checkbox-visible-column-${index}`}
                            id={`checkbox-visible-column-${index}`}
                          /> */}

                          <div className={`custom-checkbox`}>
                            {columnsVisibility[index] ? (
                              <IconCheck className="custom-check-icon" />
                            ) : (
                              <></>
                            )}
                          </div>
                          <span>{column.label}</span>
                        </div>
                      </MenuItem>
                    ))}
                  </MenuList>
                </div>
              </ClickAwayListener>
            </div>
          )}

          {/* Download */}

          <Tooltip title="Download" placement="top">
            <IconButton
              className="action-button"
              id={`action-btn-download-${id}`}
              onClick={() => {
                setIsShowingDownloadPopper(true);
              }}
            >
              <IconDownload color="secondary" />
            </IconButton>
          </Tooltip>
          {isShowingDownloadPopper && (
            <div className="download-popper">
              <ClickAwayListener
                onClickAway={(e) => {
                  setIsShowingDownloadPopper(false);
                }}
              >
                <MenuList>
                  <MenuItem
                    role="appbar-menu_item"
                    id={`menu-item-download-pdf}`}
                    key={`menu-item-download-pdf`}
                    onClick={() => {
                      setIsOpenPDFViewer(true);
                    }}
                  >
                    Download PDF
                  </MenuItem>
                  <MenuItem
                    role="appbar-menu_item"
                    id={`menu-item-download-excel}`}
                    key={`menu-item-download-excel}`}
                    onClick={() => {
                      setIsShowingDownloadPopper(false);
                      dispatch(
                        showSnackbar({
                          message: "Downloading please wait...",
                          type: "info",
                          open: true,
                        })
                      );
                    }}
                  >
                    {/* <DownloadExcelDataTable
                      data={filteredData}
                      columns={visibleColumns}
                      fileName={downloadFileName}
                      key={`${id}-download-excel`}
                    /> */}
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </div>
          )}

          {/* Print */}
          <Tooltip title="Print" placement="top">
            <IconButton
              className="action-button"
              id={`action-btn-print-${id}`}
              onClick={doPrint}
            >
              <IconPrint color="secondary" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  const BuildHeader = () => {
    return (
      <thead>
        <tr key="tr-header">
          {visibleColumns.map((column, index) => (
            <th
              key={`th-col-${index}`}
              className={
                "text-align-" +
                (column.hasOwnProperty("options")
                  ? column.options.align ?? "left"
                  : "left")
              }
            >
              <span>
                {column.label ?? ""}
                {
                  <div
                    className={
                      `sort-marker ` + getColumnSortMarkerVisibility(column)
                    }
                    id={`sort-marker-${column.name}`}
                    onClick={() => {
                      handleColumnSort(index);
                    }}
                  >
                    {sortOrder === "asc" ? (
                      <ArrowUpwardIcon className={"icon"} />
                    ) : (
                      <ArrowDownwardIcon className={"icon"} />
                    )}
                  </div>
                }
              </span>
            </th>
          ))}
          {(actions != null || action != null) && (
            <th className="td-action">Action</th>
          )}
        </tr>
      </thead>
    );
  };

  const BuildActions = (index, _item) => {
    if (actions != null) {
      return (
        <td key={`td-action-index`} className="td-action">
          <IconButton
            className="action-menu-icon"
            onClick={(e) => {
              e.preventDefault();
              let _initState = [];
              filteredData.forEach((item) => {
                _initState.push(false);
              });
              _initState[index] = true;
              setIsOpenActions(_initState);
            }}
          >
            <IconMenu className="icon" />
          </IconButton>
          {isOpenActions[index] && (
            <div key={`actions-popper-${index}`} className="actions-popper">
              <ClickAwayListener
                key={`clickaway-listener-${index}`}
                onClickAway={(e) => {
                  let _initState = [];
                  filteredData.forEach((item) => {
                    _initState.push(false);
                  });
                  setIsOpenActions(_initState);
                }}
              >
                <MenuList id={`menu-list-${index}`}>
                  {actions.map((action, _index) => {
                    let { renderCheck } = action;
                    let render = true;
                    if (renderCheck) {
                      //This should return boolean
                      render = renderCheck(_item);
                    }
                    if (render) {
                      return (
                        <>
                          <MenuItem
                            key={`action-menu-item-${_index}`}
                            role="appbar-menu_item"
                            id={`action-menu-item-${_index}`}
                            onClick={(e) => {
                              e.preventDefault();
                              action.onClick(_item);
                              let _initState = [];
                              filteredData.forEach((item) => {
                                _initState.push(false);
                              });
                              setIsOpenActions(_initState);
                            }}
                          >
                            {action.action}
                          </MenuItem>
                        </>
                      );
                    } else return <></>;
                  })}
                </MenuList>
              </ClickAwayListener>
            </div>
          )}
        </td>
      );
    } else if (action != null) {
      return (
        <td key={`td-action-index`} className="td-action">
          <div className="flex-row justify-content-center">
            <Tooltip placement="top" title={action[0].action}>
              <IconButton
                className="action-menu-icon"
                id={`action-menu-item-${index}`}
                onClick={(e) => {
                  e.preventDefault();
                  action[0].onClick(_item);
                }}
              >
                {actionIcon}
              </IconButton>
            </Tooltip>
          </div>
        </td>
      );
    } else return <></>;
  };

  const BuildBody = () => {
    return (
      <tbody>
        {filteredData
          .slice(
            (currentPageNo - 1) * rowsPerPage,
            (currentPageNo - 1) * rowsPerPage + rowsPerPage
          )
          .map((item, index) => (
            <>
              <tr key={`tr-item-${index}`}>
                {visibleColumns.map((col, _index) => (
                  <td
                    key={`td-row-${index}-col-${_index}`}
                    className={
                      "text-align-" +
                      (col.hasOwnProperty("options")
                        ? col.options.align ?? "left"
                        : "left")
                    }
                  >
                    {item[col.name] ?? ""}
                  </td>
                ))}
                {BuildActions(index, item)}
              </tr>
              <tr key={`tr-divider-${index}`}>
                <td
                  key={`td-divider-${index}`}
                  colSpan={
                    actions !== null || action !== null
                      ? visibleColumns.length + 1
                      : visibleColumns.length
                  }
                >
                  <div key={`tr-td-divider-${index}`} className="divider"></div>
                </td>
              </tr>
            </>
          ))}
      </tbody>
    );
  };

  const BuildTableFooter = () => {
    return (
      <div className="table-footer">
        <div className="left">
          <div className="flex-box">
            {filteredData.length} item(s) total
            {filteredData.length > 0 && (
              <>
                {" "}
                | Page {filteredData.length > 0 ? currentPageNo : 0} of{" "}
                {Math.ceil(filteredData.length / rowsPerPage)}
              </>
            )}
          </div>
          {filteredData.length > 0 && (
            <div className="flex-box">
              <div>Show</div>
              <TextField
                select
                variant="outlined"
                margin="dense"
                value={rowsPerPage}
                onChange={(e) => {
                  setCurrentPageNo(1);
                  setRowsPerPage(e.target.value);
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem
                    key={option + "rows-per-page-option"}
                    value={option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
              <div>rows</div>
            </div>
          )}
        </div>
        <div className="right">
          <Tooltip placement="top" title="First Page">
            <span>
              <button
                disabled={currentPageNo === 1}
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPageNo > 1) {
                    setCurrentPageNo(1);
                  }
                }}
              >{`<<`}</button>
            </span>
          </Tooltip>

          <Tooltip placement="top" title="Previous Page">
            <span>
              <button
                disabled={!(currentPageNo > 1)}
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPageNo > 1) {
                    setCurrentPageNo(currentPageNo - 1);
                  }
                }}
              >{`<`}</button>
            </span>
          </Tooltip>

          <Tooltip placement="top" title="Next Page">
            <span>
              <button
                disabled={!(currentPageNo < filteredData.length / rowsPerPage)}
                onClick={(e) => {
                  e.preventDefault();
                  if (currentPageNo < filteredData.length / rowsPerPage) {
                    setCurrentPageNo(currentPageNo + 1);
                  }
                }}
              >{`>`}</button>
            </span>
          </Tooltip>

          <Tooltip placement="top" title="Last Page">
            <span>
              <button
                disabled={
                  currentPageNo >= Math.ceil(filteredData.length / rowsPerPage)
                }
                onClick={(e) => {
                  e.preventDefault();
                  if (
                    currentPageNo < Math.ceil(filteredData.length / rowsPerPage)
                  ) {
                    setCurrentPageNo(
                      Math.ceil(filteredData.length / rowsPerPage)
                    );
                  }
                }}
              >{`>>`}</button>
            </span>
          </Tooltip>
        </div>
      </div>
    );
  };

  /* component builders */

  return (
    <>
      <div
        className={`app-data-table ${
          hasBackground ? "app-data-table-box-shadow" : ""
        }`}
        id={id}
        {...attrs}
      >
        {BuildTableTopBar()}
        {filteredData.length > 0 && (
          <div className="table-wrapper">
            <table>
              {BuildHeader()}
              {BuildBody()}
            </table>
          </div>
        )}
        {filteredData.length === 0 && (
          <div className="empty-message-container">{emptyMessage}</div>
        )}
        <BuildTableFooter />
      </div>

      {isOpenPDFViewer && (
        <DownloadPDFDataTable
          isOpen={isOpenPDFViewer}
          data={filteredData}
          columns={visibleColumns}
          fileName={downloadFileName}
          toDate={dateTo}
          fromDate={dateFrom}
          onClose={() => {
            setIsOpenPDFViewer(false);
          }}
        />
      )}
    </>
  );
};

export default AppDataTable;
